import React, { useState, useEffect } from "react";
import AutoSyncRow from "./AutoSyncRow";
import {
  DefaultButton,
  Dialog,
  DialogType,
  PrimaryButton,
} from "@fluentui/react";
import { toast } from "react-toastify";
import { cmsDisableAutoSync } from "../../CallMSAPI.js";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index.js";

var _ = require("lodash");

const NextGenSyncRow = (props) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const dismissConfirmDialog = (newVal) => {
    setShowConfirmModal(false);
    props.setFieldValue("AutoSyncToggle", newVal);
  };
  const showConfirmDialog = () => {
    setShowConfirmModal(true);
  };

  const modalProps = {
    isBlocking: true,
    className: "allow-overflow-modal",
  };

  return (
    <>
      <div className="row">
        <Dialog
          hidden={!showConfirmModal}
          onDismiss={() => dismissConfirmDialog(false)}
          modalProps={modalProps}
          style={{ minWidth: "80%", overflow: "visible" }}
          dialogContentProps={{
            type: DialogType.normal,
            title: "Confirmation Required",
            subText:
              "This action will switch off Auto Sync. You will have to manually synchronize changes.",
          }}
        >
          <div>
            <PrimaryButton
              onClick={() => {
                let tenantId = _.find(props.fullTeams[0].SyncSettings, {
                  Key: "TenantId",
                });
                let tenantIdVal = tenantId ? tenantId.Value : null;
                cmsDisableAutoSync(
                  props.account.Id,
                  props.fullTeams[0].Id,
                  tenantIdVal
                )
                  .then((res) => {
                    dismissConfirmDialog(false);
                  })
                  .catch((err) => {
                    dismissConfirmDialog(false);
                    toast.error(err.message);
                  });
              }}
              style={{ marginRight: "4px" }}
            >
              Confirm
            </PrimaryButton>
            <DefaultButton
              onClick={() => {
                dismissConfirmDialog(true);
              }}
              style={{ marginLeft: "4px" }}
            >
              Cancel
            </DefaultButton>
          </div>
        </Dialog>
        {props.values.ShowAutoSyncToggle && (
          <AutoSyncRow
            account={props.account}
            values={props.values}
            errors={props.errors}
            touched={props.touched}
            setFieldValue={props.setFieldValue}
            disabled={props.disabled}
          />
        )}
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  const account = state.account;
  const services = state.services;
  return {
    account: account.account,
    fullTeams: services.fullTeams,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refetchServices: () => dispatch(actions.refetchServices()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NextGenSyncRow);
